import React from 'react';
import { Box } from '@mui/material';
import { SvgIconProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type CircleIconBadgeViewModel = {
  icon: React.ComponentType<SvgIconProps>;
  type: Type;
};

export enum Size {
  Small,
  Large,
}

export enum Type {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'primary',
}

type CircleIconBadgeProps = {
  size?: Size;
  data: CircleIconBadgeViewModel;
  className?: string;
};

const StyledCircleIconBadge = styled(Box, {
  shouldForwardProp: (prop) => !['size', 'badgeType'].includes(prop as string),
})<{ size?: Size; badgeType: Type }>(
  ({ size = Size.Large, badgeType, theme }) => ({
    width: size === Size.Large ? '64px' : '50px',
    height: size === Size.Large ? '64px' : '50px',
    borderRadius: '100%',
    backgroundColor: theme.palette[badgeType].main,
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

const IconWrapper = styled(Box)<{ size?: Size }>(
  ({ size = Size.Large, theme }) => ({
    height: size === Size.Large ? '30px' : '20px',
    width: size === Size.Large ? '30px' : '20px',
    '& > svg': {
      width: '100%',
      height: '100%',
      fill: theme.palette.common.white,
    },
  }),
);

export const CircleIconBadge: React.FC<CircleIconBadgeProps> = ({
  size = Size.Large,
  data,
  className,
}) => {
  const IconComponent = data.icon;

  return (
    <StyledCircleIconBadge
      className={`${className || ''} circle-icon-badge`}
      size={size}
      badgeType={data.type}
    >
      <IconWrapper className='circle-icon-badge--icon' size={size}>
        <IconComponent />
      </IconWrapper>
    </StyledCircleIconBadge>
  );
};
